import { useState, useEffect, useRef } from "react";
import cotastatsimg from "../../shared/assets/charactersheets/cotastats.png";
//import cotalogo from '../../shared/assets/logos/cotalogo.png';
//import cotatitle from '../../shared/assets/logos/cotatitle.png';
import "../../shared/styles/Page.css";
import CotaCharacterSheet from "../../features/character-sheet/components/CotaCharacterSheet";
import TopBar from "../../layouts/TopBar";
import Loading from "../../shared/components/Loading";
import { getDiceBox } from "../../shared/utils/diceBox";

export default function Campaign() {
  const [mode, setMode] = useState("light");
  const [diceBoxReady, setDiceBoxReady] = useState(false);
  const diceBoxRef = useRef(null);

  useEffect(() => {
    let active = true;
    getDiceBox()
      .then((diceBox) => {
        if (!active) return;
        diceBoxRef.current = diceBox;
        setDiceBoxReady(true);
      })
      .catch((error) => {
        console.error("Failed to initialize dice box:", error);
      });

    const savedData = localStorage.getItem("appearance");
    if (savedData) {
      const { mode } = JSON.parse(savedData);
      setMode(mode);
    }

    return () => {
      active = false;
      diceBoxRef.current = null;
    };
  }, []);

  useEffect(() => {
    const appearance = {
      mode,
    };
    localStorage.setItem("appearance", JSON.stringify(appearance));
  }, [mode]);

  const darkMode = () => {
    if (mode === "dark") {
      return "_dark";
    }
    return "";
  };

  return (
    <div className="page_container">
      <div className={"page_top page_top" + darkMode()}>
        <TopBar mode={mode} setMode={setMode} />
      </div>
      <div className="page_content">
        <div className="page_1">
          {diceBoxReady ? (
            <CotaCharacterSheet
              mode={mode}
              editable={true}
              onModal={false}
              dmView={false}
              roll={true}
              diceBox={diceBoxRef.current}
            />
          ) : (
            <div className="loading-dice">
              <Loading mode={mode} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
